import { render, staticRenderFns } from "./DynamicListField.vue?vue&type=template&id=10bba897&"
import script from "./DynamicListField.vue?vue&type=script&lang=js&"
export * from "./DynamicListField.vue?vue&type=script&lang=js&"
import style0 from "./DynamicListField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports